import { Route, Routes, useNavigate } from 'react-router-dom';
import * as routes from '../constants/Routes';
import { PrivateRoute } from './PrivateRoute';
import { Navbar } from '../components/layouts/Navbar';
import { ValidationCode } from '../pages/ValidationCode';
import { Notifications } from '../pages/Notifications';
import { ConfirmRescue } from '../pages/ConfrmRescue';
import { Quiz } from '../pages/Quiz';
import { ChooseInfluencer } from '../pages/ChooseInfluencer';
import { MyBenefits } from '../pages/MyBenefits';
import { Prospects } from '../pages/Prospects';
import { Cart } from '../pages/Cart';
import { RescuesDetails } from '../pages/RescuesDetails';
import { MyRescues } from '../pages/MyRescues';
import { Results } from '../pages/Results';
import { MyIndications } from '../pages/MyIndications';
import { ActionDetails } from '../pages/ActionDetails';
import { RedeemAwards } from '../pages/RedeemAwards';
import { RegisterDetails } from '../pages/RegisterDetails';
import { Infos } from '../pages/Infos';
import { Home } from '../pages/Home';
import { EditProfile } from '../pages/editProfile';
import { Profile } from '../pages/Profile';
import { Extract } from '../pages/Extract';

export function WithAuth() {
  const navigate = useNavigate();

  if (window.location.pathname === '/') {
    navigate(routes.HOME);
  }

  return (
    <Routes>
      <Route
        path={routes.PROFILE}
        element={
          <PrivateRoute>
            <Navbar>
              <Profile />
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={routes.EDIT_PROFILE}
        element={
          <PrivateRoute>
            <Navbar>
              <EditProfile />
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={routes.HOME}
        element={
          <PrivateRoute>
            <Navbar>
              <Home />
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={`${routes.INFOS}`}
        element={
          <PrivateRoute>
            <Navbar>
              <Infos />
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={routes.REGISTER_DETAILS}
        element={
          <PrivateRoute>
            <Navbar>
              <RegisterDetails />
            </Navbar>
          </PrivateRoute>
        }
      />

      <Route
        path={routes.REDEEM_AWARDS}
        element={
          <PrivateRoute>
            <Navbar>
              <RedeemAwards />
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={`${routes.ACTION_DETAILS}/:actionId`}
        element={
          <PrivateRoute>
            <Navbar>
              <ActionDetails />
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={routes.MY_INDICATIONS}
        element={
          <PrivateRoute>
            <Navbar>
              <MyIndications />
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={routes.RESULTS}
        element={
          <PrivateRoute>
            <Navbar>
              <Results />
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={routes.MY_RESCUES}
        element={
          <PrivateRoute>
            <Navbar>
              <MyRescues />
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={`${routes.RESCUE_DETAILS}/:rescueId`}
        element={
          <PrivateRoute>
            <Navbar>
              <RescuesDetails />
            </Navbar>
          </PrivateRoute>
        }
      />

      <Route
        path={routes.CART}
        element={
          <PrivateRoute>
            <Navbar>
              <Cart />
            </Navbar>
          </PrivateRoute>
        }
      />

      <Route
        path={routes.PROSPECTS}
        element={
          <PrivateRoute>
            <Navbar>
              <Prospects />
            </Navbar>
          </PrivateRoute>
        }
      />

      <Route
        path={routes.MY_BENEFITS}
        element={
          <PrivateRoute>
            <Navbar>
              <MyBenefits />
            </Navbar>
          </PrivateRoute>
        }
      />

      <Route
        path={routes.CHOOSE_INFLUENCER}
        element={
          <PrivateRoute>
            <Navbar>
              <ChooseInfluencer />
            </Navbar>
          </PrivateRoute>
        }
      />

      <Route
        path={`${routes.QUIZ}/:actionId`}
        element={
          <PrivateRoute>
            <Navbar>
              <Quiz />
            </Navbar>
          </PrivateRoute>
        }
      />

      <Route
        path={routes.CONFIRM_RESCUE}
        element={
          <PrivateRoute>
            <Navbar>
              <ConfirmRescue />
            </Navbar>
          </PrivateRoute>
        }
      />

      <Route
        path={routes.NOTIFICATIONS}
        element={
          <PrivateRoute>
            <Navbar>
              <Notifications />
            </Navbar>
          </PrivateRoute>
        }
      />

      <Route
        path={routes.VALIDATION_CODE}
        element={
          <PrivateRoute>
            <Navbar>
              <ValidationCode />
            </Navbar>
          </PrivateRoute>
        }
      />

      <Route
        path={routes.EXTRACT}
        element={
          <PrivateRoute>
            <Navbar>
              <Extract />
            </Navbar>
          </PrivateRoute>
        }
      />

      <Route
        path="/*"
        element={
          <PrivateRoute>
            <Navbar>
              <Home />
            </Navbar>
          </PrivateRoute>
        }
      />
    </Routes>
  );
}
